import { styled } from "@mui/material/styles";
import ButtonUnstyled, { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";

const LoginButton = styled(ButtonUnstyled)(
    () => `
    &:hover {
      background-color: #222C4B;
    }
  
    &.${buttonUnstyledClasses.active} {
      background-color: #222C4B;
    }
  
    &.${buttonUnstyledClasses.focusVisible} {
      box-shadow: 0 3px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
      outline: none;
    }
  
    &.${buttonUnstyledClasses.disabled} {
      opacity: 0.5;
      cursor: not-allowed;
    }`
);

export default LoginButton;
